import React, { useState } from 'react';
import AuthenticateService from '../auth/AuthenticateService';
import { toast, ToastContainer } from 'react-toastify';
import { Link, useNavigate } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import AuthLayout from './AuthLayout';
const ForgetPassword = () => {
  const [phoneNumber, setphoneNumber] = useState('');
  const { http, setToken } = AuthenticateService();
  const [error, setError] = useState('');
  const [isLoging, setIsLoging] = useState(false)

  const navigate = useNavigate();

  const handPasswordRequest = () => {
    setIsLoging(true)
    http.post('/users/forgot-password-send-otp', {
      phone_number: phoneNumber,
    })

      .then((res) => {
        // console.log(res);

        if (res.status === 200) {
          setError('');
          toast.success(res.data.message);
          sessionStorage.setItem('resetPhoneNumber', phoneNumber);
          navigate('/reset-password');
        } else {
          setError(res.message);
          setIsLoging(false)
        }
      })
      .catch((error) => {

        // setError('Failed to resend ')users/resend-otp
        // console.log(error.response.data.message);
        toast.error('Resend Failed : ' + error.response.data.message);
        setIsLoging(false)

      });
  }

  // console.log(http);

  return (
    <AuthLayout
      brandHeading="Forgot your password?"
      brandSubheading="No worries — verify your phone number and we'll help you get back into your account."
    >
      <ToastContainer />
      <div className="auth-heading">
        <h3 className="text-1000">Forgot your password?</h3>
        <p className="text-700">
          Enter your phone number and we'll send you a code to reset it
        </p>
      </div>

      {error && (
        <div className="alert alert-outline-danger d-flex align-items-center py-2 mb-3" role="alert">
          <span className="fas fa-circle-exclamation text-danger fs--1 me-2"></span>
          <p className="mb-0 flex-1 fs--1">{error}</p>
        </div>
      )}

      <form
        onSubmit={(e) => {
          e.preventDefault();
          handPasswordRequest();
        }}
      >
        <div className="auth-field">
          <label className="form-label" htmlFor="phoneNumber">
            Phone Number
          </label>
          <div className="form-icon-container">
            <input
              id="phoneNumber"
              className="form-control form-icon-input"
              type="tel"
              value={phoneNumber}
              onChange={(e) => {
                setphoneNumber(e.target.value);
              }}
              required={true}
              placeholder="Enter your phone number"
            />
            <span className="fas fa-phone text-900 fs--1 form-icon"></span>
          </div>
        </div>

        <button className="btn-auth-primary" disabled={isLoging}>
          {isLoging ? (
            <>
              <Spinner animation="border" size="sm" /> Sending...
            </>
          ) : (
            <>
              Send Code <FontAwesomeIcon icon={faChevronRight} className="fs--1" />
            </>
          )}
        </button>
      </form>

      <div className="text-center mt-4">
        <Link className="fs--1 fw-bold" to="/">
          <span className="fas fa-arrow-left me-1"></span>Back to sign in
        </Link>
      </div>
    </AuthLayout>
  )
}

export default ForgetPassword